












import { Component, Vue, Prop } from 'vue-property-decorator'
import { addThousandSeparator } from '@/utils/CommonUtils'

@Component
export default class InputMoney extends Vue {
  @Prop() readonly value!: string | number
  @Prop({ default: false }) readonly notMillion!: boolean
  @Prop({ default: false }) readonly alignLeft!: boolean | string
  @Prop({ type: Boolean, default: true }) readonly hideSuffix!: boolean

  get displayValue () {
    let value = this.value
    if (value === null) return ''
    if (typeof value === 'string') value = parseInt(value)
    if (isNaN(value)) return ''
    if (!this.notMillion) value /= 1_000_000
    return addThousandSeparator(value)
  }

  set displayValue (val) {
    let emitVal
    if (val === '') {
      emitVal = null
    }
    else {
      const parsedValue = val.replaceAll(',', '')
      emitVal = parseInt(parsedValue)
      if (!this.notMillion) emitVal *= 1_000_000
    }
    this.$emit('input', emitVal)
  }

  get isLeftAlign () {
    return !(this.alignLeft === false)
  }
}
